export default "__VITE_ASSET__ChnicjnN__"